import { Card } from '../../Card';

import { DropdownOption } from './DropdownOption';

import type { CardProps } from '../../Card';
import type { Option } from './DropdownOption';

import s from './Dropdown.module.css';

type DropdownProps<T extends string> = Omit<CardProps, 'onSelect'> & {
  onSelect: (value: T) => void;
  options: Option<T>[];
  triggerElement: HTMLElement | null;
  value?: T;
};

export const Dropdown = <T extends string>({
  onSelect,
  options,
  triggerElement,
  value,
  ...props
}: DropdownProps<T>) => {
  const rect = triggerElement?.getBoundingClientRect();

  return (
    <Card
      style={{
        left: rect ? rect.left + rect.width / 2 + 7 : 0,
        top: rect ? rect.top - 12.5 : 0,
      }}
      background="gradient-accent"
      className={s.dropdown}
      {...props}
    >
      {options.map((option, index) => (
        <DropdownOption key={index} isSelected={option.value === value} onSelect={onSelect} option={option} />
      ))}
    </Card>
  );
};
